module.exports = __webpack_public_path__ + "static/group-image1-5e06730fbfc3eaa4a2580c2f8c1f0976.jpg";